import React from 'react';

require('../../../../styles/scss/components/bubble-message.scss');

/** BubbleMessage component. Receives props:

`text` - the message to display, string.
`type` - one of "success", "failure" or "warning". Determines the bubble's color.
`visible` - set to false to fade the bubble out (e.g. right before unmounting it).
`onClose` - optional callback invoked when the user clicks the close (x) button.
*/
export default class extends React.Component {
  static defaultProps = {
    text: "",
    type: "success",
    visible: true,
  };

  state = { closed: false };

  componentDidUpdate(prevProps) {
    // a new message coming in through the same instance should be shown again,
    // even if the previous one was manually closed
    if (prevProps.text !== this.props.text && this.state.closed) {
      this.setState({ closed: false });
    }
  }

  handleClose = () => {
    this.setState({ closed: true });
    this.props.onClose && this.props.onClose();
  };

  render() {
    const hidden = this.state.closed || !this.props.visible
    const hiddenClass = hidden ? " bubble-message-hidden" : ""
    return (
      <div className={`bubble-message bubble-message-${this.props.type}${hiddenClass}`} role="status">
        <span className="bubble-message-text">{this.props.text}</span>
        <button
          type="button"
          className="bubble-message-close"
          onClick={this.handleClose}
          aria-label={I18N._("Close")}
        >
          &times;
        </button>
      </div>
    )
  }
}
